import api from "../api/client";

const options = {
    endpoint: "api/v1/ReportingEntityMapping",
    baseEndpoint: "api/v1/ReportingEntityMapping",
    data: {},
};
export default {
    AddRequest(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/`;
        return api.postWithFiles(options);
    },
    UpdateReportingEntityRequest(id, data, token) {
        options.data = data;
        options.token = token;
        options.id = id;
        options.endpoint = `${options.baseEndpoint}`;
        return api.putwithFiles(options);
    },
    WorkflowHistoryStates(id, token) {
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/Audit/?id=${id}`;
        return api.get(options);
    },
    GetReportingEntityRequestWithTaskDetails(obj, token) {
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/RequestWithTaskDetails?id=${obj.id}&&isEdit=${obj.isEdit}`;
        return api.get(options);
    },
    RejectRequest(data, token, level) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/${level}`;
        return api.post(options);
    },
    ApproveRequest(data, token) {
        options.data = data;
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/Approve`;
        return api.post(options);
    },
    GetRequests(token, data) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.baseEndpoint}/List`;
        return api.list(options);
    },
    GetUsers(token, agencyName, name) {
        options.token = token;
        options.endpoint = `${options.baseEndpoint}/${name}/?agency=${agencyName}`;
        return api.get(options);
    },
    DownloadList(token, data) {
        options.token = token;
        options.data = data;
        options.endpoint = `${options.baseEndpoint}/DownloadList`;
        return api.download(options);
    },
};